import { useState, useEffect } from "react";
import { useExperience, useExperienceRSVPs } from "@/services/hooks";
import {
  ArrowBack,
  ArrowBackIos,
  Bookmark,
  Close,
  Event,
} from "@mui/icons-material";
import {
  AppBar,
  Avatar,
  Button,
  Box,
  Container,
  IconButton,
  Card,
  Stack,
  Toolbar,
  Typography,
  CardMedia,
} from "@mui/material";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { checkInUser } from "@/services/api";
import UserProfileDrawer from "@/components/UserProfileDrawer";

export default function ManageExperience() {
  const { key } = useParams();
  const { data: experience } = useExperience(key);

  if (!experience) {
    return <div>Loading...</div>;
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <PageAppBar />

      <Card sx={{ borderRadius: "10px", display: "flex", height: 100 }}>
        <CardMedia
          component="img"
          image={experience.meta.cover}
          alt={experience.meta.title}
          sx={{
            width: "100px",
            height: "100px",
          }}
        />
        <Stack direction="column" spacing={0.5} sx={{ p: 2 }}>
          <Typography variant="body1" sx={{ fontWeight: "600" }}>
            {experience.meta.title}
          </Typography>

          <Typography
            variant="body2"
            style={{ marginRight: "5px", color: "darkgray" }}
          >
            {experience.meta.location} • {experience.meta.when}
          </Typography>
        </Stack>
      </Card>
      <Box sx={{ mt: 4 }}>
        <UserList />
      </Box>
    </Container>
  );
}

function UserList() {
  const { key } = useParams();
  const { data } = useExperienceRSVPs(key);
  if (!data) {
    return <div>Loading...</div>;
  }
  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Bookmark color="secondary" />
        <Typography variant="h6">RSVPs ({data.length})</Typography>
      </Stack>
      <Stack direction="column" spacing={4} sx={{ mt: 4 }}>
        {data.map((user) => (
          <User key={user.key} user={user} />
        ))}
      </Stack>
    </Box>
  );
}

function User({ user }) {
  const { key } = useParams();
  const [checkedIn, setCheckedIn] = useState(user.checked_in);
  const [searchParams, setSearchParams] = useSearchParams();
  const userKey = searchParams.get("user");

  useEffect(() => {
    if (userKey === user.key) {
      setCheckedIn(true);
    }
  }, [userKey]);

  const handleCheckIn = async () => {
    await checkInUser(key, user.key);
    setCheckedIn(true);
  };
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      justifyContent="space-between"
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <UserProfileDrawer
          userKey={user.key}
          userProfile={user.meta.profile}
          avatarSize={40}
        />
        <Stack direction="column" spacing={0}>
          <Typography variant="body1" sx={{ fontWeight: "600" }}>
            {user.name}
          </Typography>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            {user.phone}
          </Typography>
        </Stack>
      </Stack>
      <Button
        variant="outlined"
        color={checkedIn ? "secondary" : "primary"}
        onClick={handleCheckIn}
      >
        {checkedIn ? "Checked In" : "Check In"}
      </Button>
    </Stack>
  );
}

function PageAppBar() {
  const navigate = useNavigate();
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{ bgcolor: "rgba(19,19,19,.9)" }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBackIos />
        </IconButton>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Event color="secondary" />
          <Typography variant="h6">Manage Experience</Typography>
        </Stack>

        {/* add a button here to launch the camera */}
        <Box sx={{ width: "40px" }} />
      </Toolbar>
    </AppBar>
  );
}
